/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The StudentMetaFctPrecontracts model module.
 * @module model/StudentMetaFctPrecontracts
 * @version 1.0.0
 */
class StudentMetaFctPrecontracts {
    /**
     * Constructs a new <code>StudentMetaFctPrecontracts</code>.
     * @alias module:model/StudentMetaFctPrecontracts
     */
    constructor() { 
        
        StudentMetaFctPrecontracts.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StudentMetaFctPrecontracts</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StudentMetaFctPrecontracts} obj Optional instance to populate.
     * @return {module:model/StudentMetaFctPrecontracts} The populated <code>StudentMetaFctPrecontracts</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StudentMetaFctPrecontracts();

            if (data.hasOwnProperty('program')) {
                obj['program'] = ApiClient.convertToType(data['program'], 'String');
            }
            if (data.hasOwnProperty('academic_program_id')) {
                obj['academic_program_id'] = ApiClient.convertToType(data['academic_program_id'], 'Number');
            }
            if (data.hasOwnProperty('precontract_id')) {
                obj['precontract_id'] = ApiClient.convertToType(data['precontract_id'], 'Number');
            }
            if (data.hasOwnProperty('formative_zone')) {
                obj['formative_zone'] = ApiClient.convertToType(data['formative_zone'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('signed')) {
                obj['signed'] = ApiClient.convertToType(data['signed'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {String} program
 */
StudentMetaFctPrecontracts.prototype['program'] = undefined;

/**
 * @member {Number} academic_program_id
 */
StudentMetaFctPrecontracts.prototype['academic_program_id'] = undefined;

/**
 * @member {Number} precontract_id
 */
StudentMetaFctPrecontracts.prototype['precontract_id'] = undefined;

/**
 * @member {String} formative_zone
 */
StudentMetaFctPrecontracts.prototype['formative_zone'] = undefined;

/**
 * @member {String} status
 */
StudentMetaFctPrecontracts.prototype['status'] = undefined;

/**
 * @member {Boolean} signed
 */
StudentMetaFctPrecontracts.prototype['signed'] = undefined;






export default StudentMetaFctPrecontracts;

